<div *ngIf="observationPoint.ObservationMeasurements?.length > 0">
  <span>
    <mat-form-field style="width: 80px !important;" *ngIf="isCreatingInspection && observationPoint.ObservationTypeName !='Evaluation' && observationPoint.ObservationTypeName !='Selection'&& observationPoint.ObservationTypeName !='Pass/Fail'&& observationPoint.ObservationTypeName !='Yes/No' " >
      <input style="width: 80px !important;" matInput  [placeholder]="'Measurement' | translate | async" type='number' [(ngModel)]="measurementOnDisplay.MeasurementReading">
      
    </mat-form-field>
    <mat-form-field style="width: 80px !important;" *ngIf="isCreatingInspection && observationPoint.ObservationTypeName =='Evaluation'" >
      <mat-select style="width: 80px !important;" [placeholder]="'Eval' | translate | async" [(ngModel)]="measurementOnDisplay.MeasurementReading"  (selectionChange)="calculateEval($event)" >
        <mat-option [value]="1" >A</mat-option>
        <mat-option [value]="2" >B</mat-option>
        <mat-option [value]="3" >C</mat-option>
        <mat-option [value]="4" >X</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 80px !important;" *ngIf="isCreatingInspection && observationPoint.ObservationTypeName =='Selection'" >
      <mat-select style="width: 80px !important;" [placeholder]="'Selection' | translate | async" [(ngModel)]="measurementOnDisplay.MeasurementReading"  (selectionChange)="calculateEval($event)" >
        <mat-option [value]="1" >{{ 'Accepted' | translate | async }}</mat-option>
        <mat-option [value]="2" >{{ 'Monitor' | translate | async }}</mat-option>
        <mat-option [value]="4" >{{ 'Not Accepted' | translate | async }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 80px !important;" *ngIf="isCreatingInspection && observationPoint.ObservationTypeName =='Pass/Fail'" >
      <mat-select style="width: 80px !important;" [placeholder]="'Pass/Fail' | translate | async" [(ngModel)]="measurementOnDisplay.MeasurementReading"  (selectionChange)="calculateEval($event)" >
        <mat-option [value]="1" >{{ 'Pass' | translate | async }}</mat-option>
        <mat-option [value]="4" >{{ 'Fail' | translate | async }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 80px !important;" *ngIf="isCreatingInspection && observationPoint.ObservationTypeName =='Yes/No'" >
      <mat-select style="width: 80px !important;" [placeholder]="'Yes/No' | translate | async" [(ngModel)]="measurementOnDisplay.MeasurementReading"  (selectionChange)="calculateEval($event)" >
        <mat-option [value]="1" >{{ 'Yes' | translate | async }}</mat-option>
        <mat-option [value]="4" >{{ 'No' | translate | async }}</mat-option>
      </mat-select>
    </mat-form-field>
    

    <div *ngIf="!isCreatingInspection && observationPoint.ObservationTypeName !='Evaluation' && observationPoint.ObservationTypeName !='Selection'&& observationPoint.ObservationTypeName !='Pass/Fail' && observationPoint.ObservationTypeName !='Yes/No'" style="margin-top:10px;">
        <!-- <click-to-edit  #measurementEditInput [editable]="true" [data]="measurementOnDisplay.MeasurementReading" (dataChanged)="updateComponentMeasurement($event)"  [alignRight]="true">
          </click-to-edit > -->
         <mat-form-field *ngIf="avg_measurement == -1" style="width: 80px !important;">
          <mat-label style="font-size: 12px ;">{{'Measurement' | translate | async}}</mat-label>
          <input type="number" matInput [(ngModel)]="measurementOnDisplay.MeasurementReading" name="MeasurementReading" (focusout)="updateComponentMeasurement(measurementOnDisplay.MeasurementReading)">
        </mat-form-field>

        <mat-form-field *ngIf="avg_measurement != -1" style="width: 90px !important;">
          <mat-label style="font-size: 12px ;">{{'Measurement' | translate | async}}</mat-label>
          <input type="number"   matInput [(ngModel)]="measurementOnDisplay.MeasurementReading" name="MeasurementReading" focusOnShow (focusout)="updateComponentMeasurement(measurementOnDisplay.MeasurementReading)">
        </mat-form-field>

        <span style="margin-left: 5px;" *ngIf="observationPoint.MaxReadings>1" >
          <mat-form-field style="width: 80px !important; " [class.shouldMarginTop] = '!isCreatingInspection'>
              <mat-select style="width: 80px !important;" [placeholder]="'Reading No.' | translate | async" [(ngModel)]="selectedMeasurementIndex">
                <mat-option [value]="reading.ReadingPosition" *ngFor="let reading of observationPoint.ObservationMeasurements" (click) = "changeMpOnDisplay(reading)" >{{ reading.ReadingPosition.toString() + " "}}</mat-option>
                <!-- <mat-option [value]="999" *ngIf="observationPoint.ObservationMeasurements?.length >= 2" (click)= "calculateAvg(observationPoint.ObservationMeasurements)">Average</mat-option> -->
              </mat-select>
            </mat-form-field>
        </span>
         <!-- <input class="input-container__input" #dataInput type="number" [value]="measurementOnDisplay.MeasurementReading" (blur)="onInputBlur(dataInput.value)" focusOnShow /> -->
         
         <!-- <get-click-to-edit *ngIf="avg_measurement == -1"  #measurementEditInput [editable]="true" [data]="measurementOnDisplay.MeasurementReading" (dataChanged)="updateComponentMeasurement($event)"  [alignRight]="true">
          </get-click-to-edit >

          <get-click-to-edit *ngIf="avg_measurement != -1"  #measurementEditInput [editable]="true" [data]="avg_measurement"  [alignRight]="true">
          </get-click-to-edit > -->
    </div>

    <div *ngIf="!isCreatingInspection && observationPoint.ObservationTypeName =='Evaluation'" style="margin-top:10px;">
      <mat-form-field style="width: 80px !important;"  >
        <mat-select style="width: 80px !important;" [placeholder]="'Eval' | translate | async" [(ngModel)]="measurementOnDisplay.MeasurementReading" (selectionChange)="calculateEval($event)">
          <mat-option [value]="1" >A</mat-option>
          <mat-option [value]="2" >B</mat-option>
          <mat-option [value]="3" >C</mat-option>
          <mat-option [value]="4" >X</mat-option>
        </mat-select>
      </mat-form-field>
  </div>

  <div *ngIf="!isCreatingInspection && observationPoint.ObservationTypeName =='Selection'" style="margin-top:10px;">
    <mat-form-field style="width: 80px !important;"  >
      <mat-select style="width: 80px !important;" [placeholder]="'Selection' | translate | async" [(ngModel)]="measurementOnDisplay.MeasurementReading" (selectionChange)="calculateEval($event)">
        <mat-option [value]="1" >{{ 'Accepted' | translate | async }}</mat-option>
        <mat-option [value]="2" >{{ 'Monitor' | translate | async }}</mat-option>
        <mat-option [value]="4" >{{ 'Not Accepted' | translate | async }}</mat-option>
      </mat-select>
    </mat-form-field>
</div>
<div *ngIf="!isCreatingInspection && observationPoint.ObservationTypeName =='Pass/Fail'" style="margin-top:10px;">
  <mat-form-field style="width: 80px !important;"  >
    <mat-select style="width: 80px !important;" [placeholder]="'Pass/Fail' | translate | async" [(ngModel)]="measurementOnDisplay.MeasurementReading" (selectionChange)="calculateEval($event)">
      <mat-option [value]="1" >{{ 'Pass' | translate | async }}</mat-option>
      <mat-option [value]="4" >{{ 'Fail' | translate | async }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div *ngIf="!isCreatingInspection && observationPoint.ObservationTypeName =='Yes/No'" style="margin-top:10px;">
  <mat-form-field style="width: 80px !important;"  >
    <mat-select style="width: 80px !important;" [placeholder]="'Yes/No' | translate | async" [(ngModel)]="measurementOnDisplay.MeasurementReading" (selectionChange)="calculateEval($event)">
      <mat-option [value]="1" >{{ 'Yes' | translate | async }}</mat-option>
      <mat-option [value]="4" >{{ 'No' | translate | async }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
  </span>
  <!-- && measurementOnDisplay.ReadingPosition!=1 -->
  
</div>
<!-- <button *ngIf="observationPoint.ObservationMeasurements?.length < observationPoint.MaxReadings"  mat-raised-button color="warn" (click)= "addNewMeasurementReading(observationPoint)"><i class="material-icons">add</i>Add New</button> -->
